// src/components/blog/BlogCta.tsx
//
// Bottom-of-article "try it free" call-to-action. Blog pages are statically
// generated, so auth state is only knowable client-side: the card stays in
// the prerendered HTML (blog traffic is overwhelmingly signed-out search
// visitors, who see no layout shift) and unmounts on hydration for signed-in
// users — a "create a free account" pitch is wrong for them.

'use client'

import Link from 'next/link'
import { useSession } from 'next-auth/react'

export default function BlogCta() {
  const { status } = useSession()
  if (status === 'authenticated') return null

  return (
    <aside className="mt-10 rounded-2xl border border-brand/30 bg-brand/5 p-6 md:p-8">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-ink">
        Ready to practice?
      </p>
      <h2 className="mt-2 text-2xl font-semibold text-foreground">
        Try UnlimitedTests free — no credit card
      </h2>
      <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
        Take a full-length adaptive Digital SAT practice test, get a topic-by-topic score breakdown,
        and see exactly which chapters to focus on next.
      </p>
      <div className="mt-5 flex flex-wrap gap-3">
        <Link
          href="/sat"
          className="inline-flex items-center rounded-xl bg-brand px-5 py-2.5 text-sm font-semibold text-on-brand transition hover:bg-brand-hover"
        >
          Start a free practice test
        </Link>
        <Link
          href="/signup"
          className="inline-flex items-center rounded-xl border border-border bg-card/60 px-5 py-2.5 text-sm font-semibold text-foreground transition hover:border-border"
        >
          Create free account
        </Link>
      </div>
    </aside>
  )
}
